/** localStorage key for persisted visitor identifier */
export const VISITOR_STORAGE_KEY = 'teo_visitor';

/** Identifier algorithm generation stored alongside the visitor id. */
export const VISITOR_ID_ALGO_VERSION = 'uuid-v7-compact-v1';

/** Compact UUID and legacy FingerprintJS IDs are both 32 hex characters. */
export const VISITOR_ID_PATTERN = /^[a-f0-9]{32}$/i;
